import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';

export const scrollToHash = (hash) => {
    if (!hash) return;

    if (hash === '#page-top') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
    }

    setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, 250); // Wait for images to finish loading (200ms)
};

export const useScrollToHash = () => {
    const { hash } = useLocation();

    useEffect(() => {
        scrollToHash(hash);
    }, [hash]);
};

export function handleSamePageScroll(e, path, hash) {
    const currentPath = window.location.pathname;
    if (currentPath === path) {
        e.preventDefault();
        scrollToHash(hash);
    }
}

export function SmoothScrollLink({ to, children }) {
    const [path, rawHash] = to.split('#');
    const hash = rawHash ? `#${rawHash}` : null;
    const handleClick = (e) => {
        if (window.location.pathname === path && hash) {
            e.preventDefault();
            scrollToHash(hash);
        }
    };

    return (
        <LinkContainer to={{ pathname: path, hash }} onClick={handleClick}>
            {children}
        </LinkContainer>
    );
}

SmoothScrollLink.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};
